import "./04_hearingAidProductsPage.css";

import NavigationBar from "../../../components/01_navigationBar/01_navigationBar";
import Footer from "../../../components/02_footer/02_footer";

import { useEffect, useRef, useState } from "react";

import img1 from "../../../assets/final/Images/05_TypesOfHearingAidsPage/01_ReceiverInCanal.jpg";
import img2 from "../../../assets/final/Images/05_TypesOfHearingAidsPage/02_SlimRIC.jpg";
import img3 from "../../../assets/final/Images/05_TypesOfHearingAidsPage/03_BehindTheEar.jpg";
import img4 from "../../../assets/final/Images/05_TypesOfHearingAidsPage/04_CustomHearingAids.jpg";
import img5 from "../../../assets/final/Images/05_TypesOfHearingAidsPage/05_ReadyToFit.jpg";

import ico1 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/01_ReceiverInCanal/no.1.png"
import ico2 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/01_ReceiverInCanal/no.2.png"
import ico3 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/01_ReceiverInCanal/no.3.png"

import ico4 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/02_Slim_RIC/no.1.png"
import ico5 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/02_Slim_RIC/no.2.png"
import ico6 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/02_Slim_RIC/no.3.png"

import ico7 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/03_BehindTheEar/no.1.png"
import ico8 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/03_BehindTheEar/no.2.png"
import ico9 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/03_BehindTheEar/no.3.png"
import ico10 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/03_BehindTheEar/no.4.png"

import ico11 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/04_CustomHearingAids/no.1.png"
import ico12 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/04_CustomHearingAids/no.2.png"
import ico13 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/04_CustomHearingAids/no.3.png"

import ico14 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/05_ReadyToFit/no.1.png"
import ico15 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/05_ReadyToFit/no.2.png"
import ico16 from "../../../assets/final/Icons/05_TypesOfHearingAidsPage/05_ReadyToFit/no.3.png"

const productAssets = {
    "ric": {
        image: img1,
        icons: {
      "Mild to severe hearing loss": ico1,
      "Everyday conversations": ico2,
      "Users looking for a discreet design": ico3,
        },
    },
    "slim-ric": {
        image: img2,
        icons: {
      "Mild to severe hearing loss": ico4,
      "Users who prefer a nearly invisible hearing aid": ico5,
      "Smartphone users": ico6,
        },
    },
    "bte": {
        image: img3,
        icons: {
            "Moderate to profound hearing loss": ico7,
            "Seniors": ico8,
            "Children": ico9,
            "Users with dexterity challenges": ico10,
        },
    },
    "custom-hearing-aids": {
        image: img4,
        icons: {
            "Users seeking a personalized fit": ico11,
            "Mild to severe hearing loss": ico12,
            "Those who prefer no device behind the ear": ico13,
        },
    },
    "ready-to-fit-cic": {
        image: img5,
        icons: {
            "Mild to moderately severe hearing loss": ico14,
            "Users wanting an almost invisible hearing aid": ico15,
            "Faster fittings": ico16,
        },
    },
};

const fallbackImage = img1;
const fallbackIcon = ico1;

export default function HearingAidsProducts() {

    const productSectionRef = useRef(null);

    const [products, setProducts] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [carouselStartIndex, setCarouselStartIndex] = useState(0);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("https://easyhear.in/products.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        "Failed to fetch hearing aid data"
                    );
                }
                return response.json();
            })

            .then((data) => {
                setProducts(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setError(error.message);
                setLoading(false);

            });
    }, []);

    const nextCarousel = () => {
        if (!products.length) {
            return;
        }

        setCarouselStartIndex((currentIndex) => (
            (currentIndex + 1) % products.length
        ));
    };

    const previousCarousel = () => {
        if (!products.length) {
            return;
        }

        setCarouselStartIndex((currentIndex) => (
            (currentIndex - 1 + products.length) %
            products.length
        ));
    };

    const selectProduct = (index) => {
        setSelectedIndex(index);
        productSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    if (loading) {
        return (
            <div>
                <NavigationBar />
                <p>
                    Loading hearing aids...
                </p>
                <Footer />
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <NavigationBar />
                <p>
                    Unable to load hearing aids.
                </p>
                <Footer />
            </div>
        );
    }

    if (!products.length) {
        return (
            <div>
                <NavigationBar />
                <p>
                    No hearing aids found.
                </p>
                <Footer />
            </div>
        );
    }

    const selectedProduct = products[selectedIndex];
    const selectedAssets =
        productAssets[selectedProduct.producturl] || {};
    const selectedProductImage =
        selectedAssets.image || fallbackImage;
    const selectedProductIcons =
        selectedAssets.icons || {};
    const visibleProducts = Array.from(
        {
            length: Math.min(3, products.length),
        },
        (_, index) => {
            const productIndex =
                (carouselStartIndex + index) %
                products.length;
            return {
                product: products[productIndex],
                index: productIndex,
            };
        }
    );

    return (
        <div>
            <NavigationBar />
            <div className="productsPage-HeroSection">
                <h1 className="Title">
                    Find the Right Hearing Aid for Your Lifestyle
                </h1>
                <p>
                    There's no one-size-fits-all hearing aid.
                    The best option depends on your hearing loss,
                    lifestyle, comfort, and personal preferences.
                    At Easy Hear, our audiologists help you choose
                    the hearing aid that fits your needs—not just
                    your hearing test.
                </p>
            </div>
            <section ref={productSectionRef} className="productsPage-ProductSection">
                <div className="productsPage-ProductImage">
                    <img src={selectedProductImage} alt={selectedProduct.productname} />
                </div>
                <div className="productsPage-ProductContent">
                    <h2>{selectedProduct.productname}</h2>
                    <p>{selectedProduct.description}</p>
                    <h3>Best for</h3>
                    <div className="productsPage-ProductSection-BestFor">
                        {selectedProduct.bestfor?.map(
                            (item, index) => {
                                const itemIcon =
                                    selectedProductIcons[item] ||
                                    fallbackIcon;
                                return (
                                    <div
                                        className="productsPage-ProductSection-BestFor-Card"
                                        key={`${item}-${index}`}
                                    >
                                        <img
                                            src={itemIcon}
                                            alt=""
                                        />
                                        <p>
                                            {item}
                                        </p>

                                    </div>

                                );

                            }
                        )}

                    </div>


                    {/* ==================================================
                        APPOINTMENT
                    ================================================== */}

                    <a
                        href="/appointment"
                        className="productsPage-AppointmentButton"
                    >
                        Book Your Appointment
                    </a>


                    {/* ==================================================
                        ADDITIONAL INFORMATION
                    ================================================== */}

                    <p className="productsPage-AdditionalInfo">
                        {selectedProduct.additionalinfo}
                    </p>


                    {/* ==================================================
                        BENEFITS
                    ================================================== */}

                    <div
                        className="
                            productsPage-InfoBlock
                            productsPage-InfoBlock-Split
                        "
                    >

                        <h3>
                            Benefits
                        </h3>


                        <ul>

                            {selectedProduct.benigits?.map(
                                (benefit, index) => (

                                    <li key={`${benefit}-${index}`}>
                                        {benefit}
                                    </li>

                                )
                            )}

                        </ul>

                    </div>


                    {/* ==================================================
                        THINGS TO CONSIDER
                    ================================================== */}

                    <div className="productsPage-InfoBlock">

                        <h3>
                            Things to Consider
                        </h3>


                        <ul>

                            {selectedProduct.things?.map(
                                (thing, index) => (

                                    <li key={`${thing}-${index}`}>
                                        {thing}
                                    </li>

                                )
                            )}

                        </ul>

                    </div>

                </div>

            </section>


            {/* ==================================================
                PRODUCT CAROUSEL
            ================================================== */}

            <section className="productsPage-ProductCarousel">

                <div className="productsPage-CarouselHeader">

                    <div className="productsPage-CarouselArrows">


                        {/* PREVIOUS BUTTON */}

                        <button
                            type="button"
                            onClick={previousCarousel}
                            aria-label="Previous hearing aids"
                            className="productsPage-CarouselArrows-Buttons"
                        >
                            &#8592;
                        </button>


                        {/* ==================================================
                            PRODUCT CARDS
                        ================================================== */}

                        <div className="productsPage-ProductCards">

                            {visibleProducts.map(
                                ({ product, index }) => {

                                    const assets =
                                        productAssets[
                                            product.producturl
                                        ] || {};

                                    const productImage =
                                        assets.image ||
                                        fallbackImage;


                                    return (

                                        <button
                                            type="button"
                                            className={`
                                                productsPage-ProductCard
                                                ${
                                                    selectedIndex === index
                                                        ? "active"
                                                        : ""
                                                }
                                            `}
                                            key={
                                                product.producturl ||
                                                index
                                            }
                                            onClick={() =>
                                                selectProduct(index)
                                            }
                                        >


                                            {/* PRODUCT CARD IMAGE */}

                                            <img
                                                src={productImage}
                                                alt={
                                                    product.productname
                                                }
                                            />


                                            {/* PRODUCT CARD CONTENT */}

                                            <div className="productsPage-ProductCardContent">

                                                <h3>
                                                    {product.productname}
                                                </h3>

                                            </div>

                                        </button>

                                    );

                                }
                            )}

                        </div>


                        {/* NEXT BUTTON */}

                        <button
                            type="button"
                            onClick={nextCarousel}
                            aria-label="Next hearing aids"
                            className="productsPage-CarouselArrows-Buttons"
                        >
                            &#8594;
                        </button>

                    </div>

                </div>

            </section>


            {/* ==================================================
                FINAL CTA
            ================================================== */}

            <section
                className="productsPage-FinalSection"
                id="appointment"
            >

                <div>

                    <h3>
                        Which Hearing Aid Is Right for You?
                    </h3>

                    <p>
                        The best hearing aid isn't simply the smallest
                        or the most advanced—it's the one that fits your
                        hearing needs, lifestyle, comfort, and daily
                        routine. At Easy Hear, our experienced
                        audiologists take the time to understand your
                        hearing profile before recommending a solution
                        that's tailored specifically to you.
                    </p>

                    <a href="/appointment">
                        Book Your Appointment
                    </a>

                </div>


                <h2 className="Quote">
                    Book a hearing assessment today and let us help
                    you find the hearing aid that's right for you.
                </h2>

            </section>


            {/* ==================================================
                FOOTER
            ================================================== */}

            <Footer />

        </div>

    );

}